//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as newsAction from '../action/newsAction';

//Material-ui
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
//Add
import moment from 'moment';
import reactStringReplace from "react-string-replace";
//Part
import PartPageTitle from './PartPageTitle';
//Icon
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



class Comp extends React.Component {

  constructor(props) {
    document.title = 'お知らせ - パートナーズ';
    super(props);

  	this.state = {
      dialogNewsId: null,
      dialogNewsDate: null,
      dialogNewsTitle: null,
      dialogNewsComment: null,
  	}
  }

  componentDidMount() {
    this.props.newsListGet(() => {
      let id = this.props.match.params.id;
      if (id) {
        //console.log(id);
        this._dialogNews(Number(id));
      }
    });
  }

  _renderList(item, index, arr) {
		return (
      <div
        key={index}
        style={{
          padding:'10px',
          borderBottom: (arr.length - 1 > index) ? 'solid 1px #DDD': '',
          backgroundColor: (item.news_unread === 1) ? '#FFE7C2': '',
          cursor:'pointer',
        }}
        onClick={ () => this._dialogNews(item.news_id) }
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            justifyContent:'start',
            alignItems:'center',
          }}
        >
          <div>
            {
              (item.news_unread === 1) ? (
                <span className='badge' style={{margin:'3px'}}></span>
              ): null
            }
          </div>
          <div style={{flex: 1}}>
            <div
              style={{
                whiteSpace:'nowrap',
                color:'#666',
                padding:'3px',
              }}
            >
              {moment(item.news_date).format("YYYY年MM月DD日")}
            </div>
            <div
              style={{
                width:'100%',
                padding:'3px',
                color:'#666',
              }}
            >
              {item.news_title}
            </div>
          </div>
          <div>
            <ChevronRightIcon style={{color:'#999'}} />
          </div>
        </div>
      </div>
    );
  };


  _dialogNews(id) {
    console.log('_dialogNews', id);
    let index = this.props.news.list.findIndex((v) => v.news_id === id);
		if (index >= 0) {
      this.setState({
        dialogNewsId: id,
        dialogNewsDate: this.props.news.list[index].news_date,
        dialogNewsTitle: this.props.news.list[index].news_title,
        dialogNewsComment: this.props.news.list[index].news_comment,
      });
      if (this.props.news.list[index].news_unread === 1) {
        this.props.newsReadEdit(id);
      }
		}
  }

  _url2Link(text) {
    if (text) {
      let urlMatches = text.match(/(https?:\/\/[\w/:%#$&?()~.=+-]+)/);

      if (urlMatches) {
        urlMatches.forEach((item, index) => {
            text = reactStringReplace(text, item, (match, i) => (
              <a
                key={ index + '-' + i }
                fontSize={'md'}
                style={{textDecorationLine: 'underline'}}
                href=  {item}
                target="_blank"
                rel="noreferrer noopener"
              >
                {item}
              </a>
            ));
        });
        return text;
      }
      else {
        return text;
      }
    }
  }

	render() {
		return (
      <div>
        <PartPageTitle
          title={'お知らせ'}
          onback={ '/' }
        />
        <div style={{maxWidth:'600px', margin:'auto'}}>

          {
            (this.props.news.datetime) && (
              (this.props.news.list.length > 0) ? (
                <div>

                  <Box boxShadow={2} style={{background:'#FFF'}}>
                    {
            					this.props.news.list.map(
                      	(value, index, arr) => this._renderList(value, index, arr)
                    	)
            				}
                  </Box>
                </div>
              ): (
                <div>
                  <h2 align='center' style={{padding:'30px 0px'}}>
                    <span className='i-b'>お知らせは</span>
                    <span className='i-b'>ありませんでした</span>
                  </h2>
                </div>
              )
            )
          }
        </div>

        <Dialog
          fullScreen
          open={ (this.state.dialogNewsId !== null) ? true: false }
          onClose={ () => this.setState({dialogNewsId: null}) }
          TransitionComponent={Transition}
          style={{maxWidth:'600px', margin:'auto'}}
          scroll='paper'
        >
          <div style={{position:'fixed',top:'0px',left:'0px',width:'100%' ,zIndex:'101'}}>
            <div style={{maxWidth:'600px', margin:'auto', background:'#FFF'}} className='shadow'>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <IconButton
                    onClick={ () => this.setState({dialogNewsId: null}) }
                  >
                    <ArrowBackIosIcon />
                  </IconButton>
                  お知らせ
                </div>

              </div>

            </div>
          </div>
          <div
            style={{
              width:'100%',
              background:'#FFF',
              paddingTop:'50px',
            }}
          >
            <div style={{margin:'3%', color:'#666'}}>
              {moment(this.state.dialogNewsDate).format("YYYY年MM月DD日")}
            </div>
            <div style={{margin:'3%',color:'#666',fontSize:'1.2em',fontWeight: "bold"}}>
              {this.state.dialogNewsTitle}
            </div>
            <div style={{margin:'3%', whiteSpace: 'pre-line',color:'#333'}}>
              { this._url2Link(this.state.dialogNewsComment) }
            </div>
          </div>
        </Dialog>
      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    news: state.news,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...newsAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
